export default __webpack_public_path__ + "media/images/portfolio/portfolio-3-082f99bb99549f1d5f881e1f99c35d74.jpg";